// eslint-disable-next-line no-shadow
export enum NotesEnum {
  Device = 'Devices',
  Location = 'Locations',
  Users = 'Users'
}
